import { useQuery } from "@tanstack/react-query";
import { api } from "../client";
import { queryKeys } from "../query-keys";

export function useMarketComponentsSelect(marketId: string | undefined) {
  return useQuery({
    queryKey: queryKeys.marketComponents.byMarket(marketId),
    enabled: !!marketId,
    queryFn: async () => {
      const res =
        await api.marketComponentApi.apiMarketComponentsMarketIdGetCollection(
          marketId!,
        );
      return res.data;
    },
    meta: {
      skipGlobalError: false,
    },
  });
}
